import { StubPage } from "./stub-page";

export function ProfilePage() {
  return (
    <StubPage
      title="Profile"
      description="Placeholder profile route — reached via the identity control at the bottom of the nav rail."
    />
  );
}
